import { Timestamp } from "../../domine/timestamp.types";
import { BrawlerStats } from "../domine/brawler-stats.types";
import { HttpFirestoreBrawlerStat } from "../firestore/firestore-battle-stats.types";
import { FirestoreFieldValue } from "../firestore/firestore.types";

export interface ModeStats {
  currentModes: ModeAndTeam[];
  mode: Mode;
}

export interface ModeAndTeam {
  mode: string;
  teamComposition: string;
}

export interface Mode {
  lastUpdate: Timestamp;
  mode: string | null;
  teamComposition: string | null;
  brawlersStats: BrawlerStats[];
}

export const ALL_ID = "all";

export type ModeId = typeof ALL_ID | string;
export type TeamId = typeof ALL_ID | string;

export interface HttpFirestoreMode {
  currentModes: {
    arrayValue: {
      values: {
        mapValue: {
          fields: {
            mode: FirestoreFieldValue;
            teamComposition: FirestoreFieldValue;
          };
        };
      }[];
    };
  };
  mode: {
    mapValue: {
      fields: {
        lastUpdate: FirestoreFieldValue;
        mode: FirestoreFieldValue;
        teamComposition: FirestoreFieldValue;
        brawlersStats: {
          arrayValue: {
            values: HttpFirestoreBrawlerStat[];
          };
        };
      };
    };
  };
}
